import store from '../store'

function isAdmin () {
  return store.state.isAdmin
}
export default function supportingDetailsSchema() {
  const packageName = store.getters.currentUserProfile?.package
  const maxFigures = store.getters.packages[packageName]?.maxFigures
  return [
    {
      type: 'textarea',
      name: 'inventionTitle',
      label: 'Title of your invention',
      validation: isAdmin ? null : 'required|min:100|max:300',
      validationMessages: {
        required: 'Invention title is required',
        min: 'Invention title must be at least 100 characters',
        max: 'Invention title must be at most 300 characters'
      }
    },
    {
      type: 'textarea',
      name: 'problemToBeSolved',
      label: 'Problem to be solved',
      validation: isAdmin ? null : 'required|min:2000|max:7000',
      validationMessages: {
        required: '"Problem to be solved" is required',
        min: 'Must be at least 2000 characters',
        max: 'Must be at most 7000 characters'
      }
    },
    {
      type: 'textarea',
      name: 'howInventionSolvesProblem',
      label: 'How does your invention solve the problem?',
      validation: isAdmin ? null : 'required|min:2000|max:7000',
      validationMessages: {
        required: '"Problem to be solved" is required',
        min: 'Must be at least 2000 characters',
        max: 'Must be at most 7000 characters'
      }
    },
    {
      type: 'textarea',
      name: 'keyElement',
      label: 'What are the key elements that make your invention unique?',
      validation: isAdmin ? null : 'required|min:100|max:500',
      validationMessages: {
        required: 'Key element is required',
        min: 'Key element must be at least 100 characters',
        max: 'Key element must be at most 500 characters'
      }
    },
    {
      name: 'figures',
      type: 'group',
      repeatable: true,
      class: 'field-group figure',
      addLabel: '+ Add another figure',
      minimum: 1,
      limit: maxFigures,
      children: [
        {
          component: 'h4',
          name: 'certsLabel',
          children: 'Figure details'
        },
        {
          name: 'document',
          label: 'Upload a document',
          type: 'file',
          value: [{ url: null }],
          validation: isAdmin ? null : 'required'
        },
        {
          name: 'titleSummary',
          type: 'textarea',
          label: 'Title & Summary',
          validation: isAdmin ? null : 'required|min:50|max:500',
          validationMessages: {
            required: 'Title & Summary is required',
            min: 'Must be at least 50 characters',
            max: 'Must be at most 500 characters'
          }
        },
        {
          name: 'description',
          type: 'textarea',
          label: 'Description of every element represented in figure',
          validation: isAdmin ? null : 'required|min:300|max:7000',
          validationMessages: {
            required: 'Description is required',
            min: 'Description must be at least 100 characters',
            max: 'Description must be at most 300 characters'
          }
        },
      ]
    },
    {
      name: 'featuresOfInterest',
      type: 'textarea',
      label: 'Features of interest',
      validation: isAdmin ? null : 'required|min:100|max:500',
      validationMessages: {
        required: '"Features of interest" is required',
        min: 'Must be at least 100 characters',
        max: 'Must be at most 300 characters'
      }
    },
    {
      name: 'howInventionCanBeUsed',
      type: 'textarea',
      label: 'Describe how your invention can be used by your target customers. Why would somebody want to use your invention?',
      validation: isAdmin ? null : 'required|min:100|max:500',
      validationMessages: {
        required: 'Field is required',
        min: 'Must be at least 100 characters',
        max: 'Must be at most 300 characters'
      }
    }
  ]
}
